<template>
    <div v-if="show" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
        <div class="bg-white p-4 rounded-lg shadow-xl max-w-2xl w-full"  style="max-height: 80vh;" >
            <div class="flex justify-between items-center mb-4">
                <h3 class="text-xl font-semibold">{{ staffName }}</h3>
                <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg>
                </button>
            </div>
            <div class="flex justify-center items-center">
                <img :src="imageUrl" :alt="staffName" class="rounded-lg" style="max-width: 100%; max-height: 100%;">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StaffImageModal',
    props: {
        show: Boolean,
        imageUrl: String,
        staffName: String,
    },
}
</script>